import { ModalWrapperProps, PullToRefreshModalWrapperProps } from "../types/Props";
import PullToRefreshWrapper from "./PullToRefreshWrapper";

export const ModalWrapper = ({ title, onClose, children }: ModalWrapperProps) => {
  return (
    <div className="modal-container">
      <div className="modal-content-full">
        <div className="top-bar-modal">
          <h2>{title}</h2>
          <button className='modal-close' onClick={onClose}>X</button>
        </div>
        <div className="modal-content">
          {children}
        </div>
      </div>
    </div>
  )
};

export const PullToRefreshModalWrapper = ({ title, onClose, onRefresh, children }: PullToRefreshModalWrapperProps) => {
  return (
    <div className="modal-container">
      <PullToRefreshWrapper className={'modal-content-full'} onRefresh={onRefresh}>
        <div className="top-bar-modal">
          <h2>{title}</h2>
          <button className='modal-close' onClick={onClose}>X</button>
        </div>
        <div className="modal-content">
          {children}
        </div>
      </PullToRefreshWrapper>
    </div>
  )
};